module.exports = __webpack_public_path__ + "static/img03-dbe727e854a81a0768e40d0c7f39483b.png";